import React, { useEffect, useRef, useState } from "react";
import { getStoredTheme } from "../lib/theme";

/**
 * Generic TradingView embed widget loader.
 * widgetType: name from the embed-widget URL (e.g. "symbol-overview", "technical-analysis", ...)
 *
 * Re-mounts on theme change (listens to "ft:theme-change" custom event).
 */
export default function TVWidget({ widgetType, config, height = 200, testid }) {
  const ref = useRef(null);
  const [theme, setTheme] = useState(getStoredTheme());

  useEffect(() => {
    const handler = (e) => setTheme(e.detail.theme);
    window.addEventListener("ft:theme-change", handler);
    return () => window.removeEventListener("ft:theme-change", handler);
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.innerHTML = "";
    const wrap = document.createElement("div");
    wrap.className = "tradingview-widget-container__widget";
    wrap.style.height = "100%";
    wrap.style.width = "100%";
    node.appendChild(wrap);
    const isDark = theme !== "light";
    const script = document.createElement("script");
    script.src = `https://s3.tradingview.com/external-embedding/embed-widget-${widgetType}.js`;
    script.async = true;
    script.type = "text/javascript";
    script.innerHTML = JSON.stringify({
      colorTheme: isDark ? "dark" : "light",
      isTransparent: true,
      locale: "de_DE",
      backgroundColor: isDark ? "rgba(9, 9, 11, 1)" : "rgba(255, 255, 255, 1)",
      ...config,
    });
    node.appendChild(script);
  }, [widgetType, JSON.stringify(config), theme]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      ref={ref}
      className="tradingview-widget-container border border-zinc-800 bg-zinc-950 overflow-hidden"
      data-testid={testid || `tv-widget-${widgetType}`}
      style={{ height: `${height}px`, width: "100%" }}
    />
  );
}
